import { SECTIONS, SectionId } from './sections';
import { useEditor } from '../state/store';
import { ToolId } from '../tools/types';

/**
 * The left rail: one entry per section, icon over label.
 *
 * Switching section also switches to that section's primary tool, so a single
 * click both changes what the panel shows and what the mouse does.
 */
export function Rail({
  active,
  onSelect,
}: {
  active: SectionId;
  onSelect: (id: SectionId) => void;
}): JSX.Element {
  const setTool = useEditor((s) => s.setTool);

  return (
    <nav className="rail">
      {SECTIONS.map((section, i) => {
        const Icon = section.icon;
        const isActive = active === section.id;
        return (
          <div key={section.id} style={{ display: 'contents' }}>
            {i === 6 || i === 9 ? <div className="rail-sep" /> : null}
            <button
              className={`rail-item${isActive ? ' active' : ''}`}
              onClick={() => {
                onSelect(section.id);
                if (section.defaultTool) setTool(section.defaultTool as ToolId);
              }}
              title={section.description}
            >
              <Icon size={19} strokeWidth={1.75} />
              <span>{section.label}</span>
            </button>
          </div>
        );
      })}
    </nav>
  );
}
